<!-- Only Spinner (under 3s) -->
<app-progress-bar-circular
  *ngIf="isLoading && !showMessage"
  class="spinner-alone"
  [size]="{ width: 80, height: 80 }"
  [playAnimation]="play$"
  [stopAnimation]="stop$"
  [determined]="false"
/>

<!-- Spinner + Message (after 3s) -->
<div class="message-wrapper" *ngIf="isLoading && showMessage">
  <div class="message-modal">
    <app-progress-bar-circular
      [size]="{ width: 80, height: 80 }"
      [playAnimation]="play$"
      [stopAnimation]="stop$"
      [determined]="false"
    ></app-progress-bar-circular>

    <div class="text">
      <p [innerHTML]="loadingMessage"></p>
      <button (click)="onCancel()">Cancel</button>
    </div>
  </div>
</div>
